export type DataGridItem = {
  label: string;
  value: React.ReactNode;
  span?: boolean; // full-width item
};

type Props = {
  items: DataGridItem[];
  columns?: 1 | 2 | 3;
  style?: React.CSSProperties;
};

export function DataGrid({ items, columns = 2, style }: Props) {
  return (
    <dl
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: '1px',
        background: 'var(--border-subtle)',
        border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-lg)',
        overflow: 'hidden',
        margin: 0,
        ...style,
      }}
    >
      {items.map((item, i) => (
        <div
          key={i}
          style={{
            background: 'var(--surface-base)',
            padding: '12px 16px',
            gridColumn: item.span ? `1 / -1` : undefined,
          }}
        >
          <dt
            style={{
              fontSize: 'var(--text-xs)',
              fontWeight: 600,
              color: 'var(--text-tertiary)',
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              margin: '0 0 4px',
            }}
          >
            {item.label}
          </dt>
          <dd
            style={{
              margin: 0,
              fontSize: 'var(--text-sm)',
              color: 'var(--text-primary)',
              fontWeight: 500,
            }}
          >
            {item.value ?? <span style={{ color: 'var(--text-placeholder)' }}>—</span>}
          </dd>
        </div>
      ))}
    </dl>
  );
}
